import UIkit from 'uikit/dist/js/uikit-core';

const initFiltroApuntes = () => {
    const wrapper = document.querySelector('.mi-cuenta__mis-apuntes');
    if (!wrapper) return;

    const contenedor = wrapper.querySelector('.contenedor-apuntes');
    if (!contenedor) return;

    function initAccionesApuntes() {
        const botonesEditar = contenedor.querySelectorAll('.editar-apunte-btn');
        const botonesCancelar = contenedor.querySelectorAll('.cancelar-edicion-apunte');
        const botonesGuardar = contenedor.querySelectorAll('.guardar-edicion-apunte');
        const botonesEliminar = contenedor.querySelectorAll('.eliminar-apunte-btn');

        botonesEditar.forEach(btn => {
            btn.onclick = function (e) {
                e.preventDefault();

                const id = this.dataset.id;

                const contenido = contenedor.querySelector(`#contenido-apunte-${id}`);
                const form = contenedor.querySelector(`#form-editar-apunte-${id}`);

                if (!contenido || !form) return;

                contenido.style.display = 'none';
                form.style.display = 'block';
            };
        });

        botonesCancelar.forEach(btn => {
            btn.onclick = function (e) {
                e.preventDefault();

                const id = this.dataset.id;

                const contenido = contenedor.querySelector(`#contenido-apunte-${id}`);
                const form = contenedor.querySelector(`#form-editar-apunte-${id}`);

                if (!contenido || !form) return;

                form.style.display = 'none';
                contenido.style.display = 'block';
            };
        });

        botonesGuardar.forEach(btn => {
            btn.onclick = function (e) {
                e.preventDefault();

                const id = this.dataset.id;
                const user_id = this.dataset.user;
                const form = contenedor.querySelector(`#form-editar-apunte-${id}`);

                if (!form) return;

                const textarea = form.querySelector('.textarea-editar-apunte');
                const contenido = textarea ? textarea.value : '';

                if (!contenido.trim()) {
                    alert('El apunte no puede estar vacío.');
                    return;
                }

                this.disabled = true;
                this.textContent = 'Guardando...';

                fetch('/wp-json/apuntes-rest/v1/update', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-WP-Nonce': user_acciones_rest.apiNonce
                    },
                    body: JSON.stringify({
                        data: {
                            id_apunte: id,
                            contenido: contenido,
                            user_id: user_id
                        }
                    })
                })
                .then(response => response.json())
                .then(response => {
                    if (!response.success) {
                        alert(response.message || 'No se pudo editar el apunte.');
                        return;
                    }

                    const contenidoApunte = contenedor.querySelector(`#contenido-apunte-${id}`);

                    if (contenidoApunte) {
                        contenidoApunte.innerHTML = response.html || contenido;
                        contenidoApunte.style.display = 'block';
                    }

                    form.style.display = 'none';

                    if (window.UIkit) {
                        UIkit.update(form.closest('.contenedor-leccion-apunte'));
                    }
                })
                .catch(error => {
                    console.error('Error editando apunte:', error);
                })
                .finally(() => {
                    this.disabled = false;
                    this.textContent = 'Guardar cambios';
                });
            };
        });

        botonesEliminar.forEach(btn => {
            btn.onclick = function (e) {
                e.preventDefault();

                const id = this.dataset.id;
                const user_id = this.dataset.user;

                if (!confirm('¿Seguro que quieres eliminar este apunte? Esta acción no se puede deshacer.')) {
                    return;
                }

                const contenedorApunte = this.closest('.contenedor-leccion-apunte');

                this.disabled = true;

                fetch('/wp-json/apuntes-rest/v1/delete', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-WP-Nonce': user_acciones_rest.apiNonce
                    },
                    body: JSON.stringify({
                        data: {
                            id_apunte: id,
                            user_id: user_id
                        }
                    })
                })
                .then(response => response.json())
                .then(response => {
                    if (!response.success) {
                        alert(response.message || 'No se pudo eliminar el apunte.');
                        return;
                    }

                    if (contenedorApunte) {
                        contenedorApunte.remove();
                    }
                })
                .catch(error => {
                    console.error('Error eliminando apunte:', error);
                })
                .finally(() => {
                    this.disabled = false;
                });
            };
        });
    }

    const filtrosModulo = wrapper.querySelectorAll('[data-modulo]');
    const filtrosLeccion = wrapper.querySelectorAll('[data-leccion]');
    const filtrosOrden = wrapper.querySelectorAll('[data-order]');

    let filtroModulo = 'Todos';
    let filtroLeccion = 'Todas';
    let filtroOrden = 'mas-recientes';

    function filtrarApuntes() {
        contenedor.classList.add('loading');

        fetch('/wp-json/apuntes-rest/v1/filter', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-WP-Nonce': user_acciones_rest.apiNonce
            },
            body: JSON.stringify({
                data: {
                    modulo: filtroModulo,
                    leccion: filtroLeccion,
                    orden: filtroOrden
                }
            })
        })
        .then(response => response.json())
        .then(response => {
            if (!response.success) return;

            contenedor.innerHTML = response.html;

            initAccionesApuntes();

            if (window.UIkit) {
                UIkit.update(contenedor);
            }

            scrollToApuntes();
        })
        .catch(error => {
            console.error('Error filtrando apuntes:', error);
        })
        .finally(() => {
            contenedor.classList.remove('loading');
        });
    }

    function activarBoton(botones, botonActivo) {
        botones.forEach(btn => btn.classList.remove('active'));
        botonActivo.classList.add('active');
    }

    function actualizarTextoDropdown(boton, textoDefault) {
        const inline = boton.closest('.uk-inline');
        const span = inline?.querySelector('button.uk-button span');

        if (!span) return;

        span.textContent = boton.textContent.trim() || textoDefault;
    }

    function cerrarDropdown(boton) {
        const dropdownElement = boton.closest('.uk-inline')?.querySelector('[uk-dropdown]');

        if (dropdownElement && window.UIkit) {
            UIkit.dropdown(dropdownElement).hide(false);
        }
    }

    function scrollToApuntes() {
        const offset = 80;
        const top = wrapper.getBoundingClientRect().top + window.pageYOffset - offset;

        window.scrollTo({
            top,
            behavior: 'smooth'
        });
    }

    filtrosModulo.forEach(btn => {
        btn.addEventListener('click', function () {
            filtroModulo = this.dataset.modulo || 'Todos';
            filtrarDropdownLeccionesPorModulo(filtroModulo);

            activarBoton(filtrosModulo, this);
            actualizarTextoDropdown(this, 'Módulo');
            cerrarDropdown(this);

            const leccionActiva = wrapper.querySelector('[data-leccion].active');

            if (
                leccionActiva &&
                filtroModulo !== 'Todos' &&
                leccionActiva.dataset.leccion !== 'Todas' &&
                String(leccionActiva.dataset.moduloPadre) !== String(filtroModulo)
            ) {
                leccionActiva.classList.remove('active');

                const botonTodas = wrapper.querySelector('[data-leccion="Todas"]');
                if (botonTodas) {
                    botonTodas.classList.add('active');
                }

                filtroLeccion = 'Todas';

                const spanLeccion = wrapper.querySelector('.dropdown-lecciones .uk-button span');
                if (spanLeccion) {
                    spanLeccion.textContent = 'Lección específica';
                }
            }

            filtrarApuntes();
        });
    });

    filtrosLeccion.forEach(btn => {
        btn.addEventListener('click', function () {
            filtroLeccion = this.dataset.leccion || 'Todas';

            activarBoton(filtrosLeccion, this);
            actualizarTextoDropdown(this, 'Lección específica');
            cerrarDropdown(this);

            filtrarApuntes();
        });
    });

    filtrosOrden.forEach(btn => {
        btn.addEventListener('click', function () {
            filtroOrden = this.dataset.order || 'mas-recientes';

            activarBoton(filtrosOrden, this);
            actualizarTextoDropdown(this, 'Más recientes primero');
            cerrarDropdown(this);

            filtrarApuntes();
        });
    });

    function filtrarDropdownLeccionesPorModulo(moduloSeleccionado) {
        filtrosLeccion.forEach(btn => {
            const item = btn.closest('li');
            const moduloPadre = btn.dataset.moduloPadre || '';
            const leccion = btn.dataset.leccion || '';

            if (!item) return;

            const mostrar =
                moduloSeleccionado === 'Todos' ||
                leccion === 'Todas' ||
                String(moduloPadre) === String(moduloSeleccionado);

            item.style.display = mostrar ? '' : 'none';
        });
    }

    initAccionesApuntes();
};

export default initFiltroApuntes;